// NGXS actions must stay newable classes: withActions/createDispatchMap in
// @res/ngg-core is typed over ActionDef, which requires a `new (...args)`
// signature, and the dispatcher matches action results by reference identity.
// The parameterless ones therefore carry a mirror instance field so they are
// not classes of statics only. NGXS resolves the type from constructor.type
// first, so the dispatched string is unchanged.
import { DateRangeType } from '@res/ng-data-access';
import { TypesaurusCoreDoc } from '@res/ngg-core';
import { AdvancedFilterModel, FilterModel, IServerSideGetRowsRequest } from 'ag-grid-community';
import { PartnerModel, PartnerRef, PartnerUpdateData } from '../../schema/schema.interface';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace PartnerActions {
  export class OnGetAllPartner {
    static readonly type = '[Partner] OnGetAllPartner';
    readonly type = OnGetAllPartner.type;
  }

  export class GetAllPartner {
    static readonly type = '[Partner] GetAllPartner';
    readonly type = GetAllPartner.type;
  }

  export class InitPartnersCount {
    static readonly type = '[Partner] InitPartnersCount';
    readonly type = InitPartnersCount.type;
  }

  export class InitPartners {
    static readonly type = '[Partner] InitPartners';
    readonly type = InitPartners.type;
  }
  export class CountPartners {
    static readonly type = '[Partner] CountPartners';
    readonly type = CountPartners.type;
  }

  export class ClosePartnersConnection {
    static readonly type = '[Partner] ClosePartnersConnection';
    readonly type = ClosePartnersConnection.type;
  }

  export class GetPartnerById {
    static readonly type = '[Partner] GetPartnerById';
    readonly type = GetPartnerById.type;
  }

  export class UpdatePartner {
    static readonly type = '[Partner] UpdatePartner';
    constructor(
      public partnerData: Partial<PartnerUpdateData>,
      public ref: PartnerRef,
    ) {}
  }

  export class DeletePartners {
    static readonly type = '[Partner] DeletePartners';
    constructor(public refs: PartnerRef[] | PartnerRef) {}
  }

  export class PaginateQueryPartner {
    static readonly type = '[Partner] PaginateQueryPartner';
    constructor(
      public request: IServerSideGetRowsRequest,
      public isResetAfterFilterOrSort = false,
      public userId?: string,
    ) {}
  }
  export class PartnerError {
    static readonly type = '[Partner] PartnerError';
    constructor(public error: Error) {}
  }

  export class GetSumOf {
    static readonly type = '[Partner] GetSumOf';
    constructor(
      public field: string,
      public timePeriod: DateRangeType,
    ) {}
  }
  export class SavePartner {
    static readonly type = '[Partner] SavePartner';
    constructor(public partnerData: PartnerUpdateData) {}
  }
  export class GetSumsCountOf {
    static readonly type = '[Partner] GetSumsCountOf';
    constructor(
      public fields: {
        sumId: string;
        countId: string;
        countValue: number | string | boolean | Date;
      }[],
      public timePeriod: DateRangeType,
      public filterModel?: FilterModel | AdvancedFilterModel | null,
      public userId?: string,
    ) {}
  }

  export class UpdatePartnerResult {
    static readonly type = '[Partner] UpdatePartnerResult';
    constructor(public data: Array<TypesaurusCoreDoc<PartnerModel> | null | undefined>) {}
  }
}
